export const DEFAULT_LANG = "en_US";

export const ENGLISH_PATH_PREFIXES = ["en_US", "en-us", "en"];

export const KNOWN_PATH_LANGS = [
  "en_US",
  "zh_CN",
  "zh_TW",
  "ru_RU",
  "ko_KR",
  "ja_JP",
  "id_ID",
  "vi_VN",
];

// URL 路径段（小写连字符）<-> 内部语言 key（下划线）
export const LANG_PATH_MAP = {
  en_US: "en-us",
  zh_CN: "zh-cn",
  zh_TW: "zh-tw",
  ko_KR: "ko-kr",
  ja_JP: "ja-jp",
  ru_RU: "ru-ru",
  id_ID: "id-id",
  vi_VN: "vi-vn",
};

export function isEnglishLang(lang) {
  return lang === DEFAULT_LANG;
}

export function isEnglishPathPrefix(segment) {
  if (!segment) return false;
  return ENGLISH_PATH_PREFIXES.some(
    (prefix) => segment.toLowerCase() === prefix.toLowerCase(),
  );
}

export function langToPathSegment(lang) {
  if (!lang) return "";
  return LANG_PATH_MAP[lang] || lang.replace("_", "-").toLowerCase();
}

export function pathSegmentToLang(segment) {
  if (!segment) return null;

  const langList =
    (typeof window !== "undefined" && window._langList) || KNOWN_PATH_LANGS;

  if (langList.indexOf(segment) > -1 || KNOWN_PATH_LANGS.indexOf(segment) > -1) {
    return segment;
  }

  const lower = segment.toLowerCase();
  const fromMap = Object.entries(LANG_PATH_MAP).find(([, path]) => path === lower);
  if (fromMap) {
    return fromMap[0];
  }

  const parts = lower.split("-");
  if (parts.length === 2) {
    const langKey = `${parts[0]}_${parts[1].toUpperCase()}`;
    if (langList.indexOf(langKey) > -1 || KNOWN_PATH_LANGS.indexOf(langKey) > -1) {
      return langKey;
    }
  }

  return null;
}

export function isPathLangSegment(segment) {
  if (!segment || isEnglishPathPrefix(segment)) return false;
  return pathSegmentToLang(segment) !== null;
}

export function isLegacyUnderscoreLangPath(segment) {
  return !!segment && /^[a-z]{2}_[A-Z]{2}$/.test(segment);
}

export function getLangPathPrefix(lang) {
  const resolvedLang =
    lang ||
    (typeof localStorage !== "undefined" ? localStorage.lang : "") ||
    DEFAULT_LANG;
  return isEnglishLang(resolvedLang) ? "" : `/${langToPathSegment(resolvedLang)}`;
}

export function getLangFromPath(pathname) {
  const segments = (pathname || window.location.pathname)
    .replace(/^\/{1,}/, "/")
    .split("/")
    .filter(Boolean);
  const first = segments[0] || "";
  const lang = pathSegmentToLang(first);

  if (lang) {
    return lang;
  }
  if (isEnglishPathPrefix(first)) {
    return DEFAULT_LANG;
  }
  return DEFAULT_LANG;
}

export function stripLangPrefix(pathname) {
  const segments = pathname.split("/").filter(Boolean);

  if (
    segments.length &&
    (isPathLangSegment(segments[0]) || isEnglishPathPrefix(segments[0]))
  ) {
    segments.shift();
  }
  return segments.length ? `/${segments.join("/")}` : "/";
}

export function buildLangPath(lang, path = "") {
  const normalizedPath = path
    ? path.startsWith("/")
      ? path
      : `/${path}`
    : "";
  if (isEnglishLang(lang)) {
    return normalizedPath || "/";
  }
  return `/${langToPathSegment(lang)}${normalizedPath}`;
}

export function switchLangPath(currentPathname, newLang) {
  const restPath = stripLangPrefix(currentPathname);
  return buildLangPath(newLang, restPath === "/" ? "" : restPath);
}

export function getCanonicalLangPath(lang, restPath = "") {
  const suffix = restPath ? (restPath.startsWith("/") ? restPath : `/${restPath}`) : "";
  if (isEnglishLang(lang)) {
    return suffix || "/";
  }
  return `/${langToPathSegment(lang)}${suffix}`;
}
